export enum ActivityActions {
  CREATE = "Create",
  UPDATE = "Update",
  SET_REVISION = "Revision",
  SET_FINAL = "Final",
  SET_NOT_FINAL = "Not Final",
  STATUS_CHANGED = "Status Changed",
}

export const WorkDocketToastMessages = {
  DELETED: "Work docket deleted successfully.",
  WORK_DOCKET_APPROVED: "Work Docket has been Approved.",
  WD_STATUS_UPDATED: "Work docket status update successfully.",
  WD_CREATED: "Work docket created successfully.",
  WD_UPDATED: "Work docket updated successfully.",
  WD_VOIDED: "Work docket marked as voided successfully.",
  TABLE_UPDATED: "Work Docket table updated successfully.",
};

export const EmptyWorkDocketTableMessage = {
  SUBTITLE: "Add new work docket report",
  BTN_LABEL: "Add New Report",
};

export enum WorkDocketStatusColor {
  AWAITING_FOR_APPROVAL = "#A970FF",
  APPROVED = "#28C76F",
  DISPUTED = "#FFC300",
  READY_TO_INVOICE = "#007BFF",
  VOIDED = "#8B0C0C",
  CLAIMED_BY_CA = "#D95117",
  MANUALLY_CLAIMED = "#D004D3",
  DRAFT = "#6E6E6E",
  SUBMITTED = "#FF6F61",
  DELETED = "#D30404",
  AUTHORISED = "#A31188",
  PAID = "#179933",
}
export enum WorkDocketStatus {
  AWAITING_FOR_APPROVAL = "AWAITING_FOR_APPROVAL",
  APPROVED = "APPROVED",
  READY_TO_INVOICE = "READY_TO_INVOICE",
  VOIDED = "VOIDED",
  CLAIMED_BY_CA = "CLAIMED_BY_CA",
  DISPUTED = "DISPUTED",
  MANUALLY_CLAIMED = "MANUALLY_CLAIMED",
}

export const WorkDocketErrorMessages = {
  STATUS_CHANGED_FAILED: "Error occurred while changing status.",
  PDF_GENERATION_FAILED: "Error occurred while generating PDF.",
};
